import { createSlice } from '@reduxjs/toolkit';

const userSlice = createSlice({
  name: 'users',
  initialState: {
    userData: null,
    loading: false,
    error: null
  },
  reducers: {
    getAllUsersStart: (state) => {
      state.loading = true;
    },
    getAllUsersSuccess: (state, { payload }) => {
      state.loading = false;
      state.error = null;
      state.userData = payload;
    },
    getAllUsersFailure: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
    clearAllUsers: (state) => ({
      ...state,
      userData: null
    }),
  }
});

export const { getAllUsersStart, getAllUsersSuccess, getAllUsersFailure, clearAllUsers } = userSlice.actions;
export default userSlice.reducer;
